import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const FAQIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "FAQIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M11.9311 16.5786C11.6548 16.5786 11.4311 16.355 11.4311 16.0786V10.9272H10.8984C10.6221 10.9272 10.3984 10.7036 10.3984 10.4272C10.3984 10.1509 10.6221 9.92725 10.8984 9.92725H11.9311C12.2075 9.92725 12.4311 10.1509 12.4311 10.4272V16.0786C12.4311 16.355 12.2075 16.5786 11.9311 16.5786Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.229 16.6821H10.771C10.4946 16.6821 10.271 16.4585 10.271 16.1821C10.271 15.9058 10.4946 15.6821 10.771 15.6821H13.229C13.5054 15.6821 13.729 15.9058 13.729 16.1821C13.729 16.4585 13.5054 16.6821 13.229 16.6821Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.9326 8.31739C11.8027 8.31739 11.6728 8.26759 11.5728 8.16749C11.5327 8.12745 11.4927 8.06739 11.4726 8.00733C11.4429 7.94776 11.4326 7.8877 11.4326 7.81739C11.4326 7.68751 11.4829 7.55762 11.5728 7.46778C11.7627 7.27735 12.103 7.27735 12.2827 7.46778C12.333 7.50733 12.3628 7.56739 12.3926 7.62745C12.4228 7.68751 12.4326 7.75733 12.4326 7.81739C12.4326 7.8877 12.4228 7.94776 12.3926 8.00733C12.3628 8.06739 12.333 8.12745 12.2827 8.16749C12.1929 8.26759 12.063 8.31739 11.9326 8.31739Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.8457 22H12.1719C12.1484 22 12.125 21.9985 12.102 21.9951L12 22C6.48584 22 2 17.5142 2 12C2 6.48584 6.48583 2 12 2C17.5141 2 22 6.48584 22 12C22 14.6435 20.9375 17.1865 19.0683 19.0586L21.1958 21.1431C21.3408 21.2852 21.3852 21.501 21.3086 21.689C21.2319 21.877 21.0488 22 20.8457 22ZM12.2685 21H19.6206L17.998 19.4102C17.8994 19.314 17.8452 19.1807 17.8481 19.043C17.8511 18.9048 17.9111 18.7739 18.0137 18.6816C19.9116 16.9722 21 14.5371 21 12C21 7.0376 16.9624 3 12 3C7.0376 3 2.99999 7.0376 2.99999 12C2.99999 16.9624 7.03759 21 12 21L12.167 20.9912C12.2041 20.9946 12.2358 20.9937 12.2685 21Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default FAQIcon;
